import { props } from '@ngrx/store';
import { createAsyncAction } from '../../../core/async-state/utils/async-state-action.utils';
import { GetSubmissionsResponse } from '../../../shared/models/responses/get-submissions-response.modal';
import { SubmissionDetails } from 'ngx-esprio-shared';

export namespace SubmissionApiActions {
  enum SubmissionApiActionTypes {
    GetSubmissions = '[Submission API] Get submissions',
    GetSubmissionsSuccess = '[Submission API] Get submissions success',
    GetSubmissionsFail = '[Submission API] Get submissions fail',
    GetSubmissionDetails = '[Submission API] Get submission Details',
    GetSubmissionDetailsSuccess = '[Submission API] Get submission Details success',
    GetSubmissionDetailsFail = '[Submission API] Get submission Details fail',
    LoadLatestSubmissionDetails = '[Submissions] Load Latest Submission Details',
    LoadLatestSubmissionDetailsSuccess = '[Submissions] Load Latest Submission Details Success',
    LoadLatestSubmissionDetailsFail = '[Submissions] Load Latest Submission Details Fail',
    ClearSubmissionDetails =  '[Submissions] Clear Submission Details',
  }

  export const getSubmissions = createAsyncAction(
    SubmissionApiActionTypes.GetSubmissions,
    {
      asyncKey: SubmissionApiActionTypes.GetSubmissions,
      asyncState: 'start',
    },
    props<{ userId: string, monitoredUserId: string }>(),
  );

  export const getSubmissionsSuccess = createAsyncAction(
    SubmissionApiActionTypes.GetSubmissionsSuccess,
    {
      asyncKey: SubmissionApiActionTypes.GetSubmissions,
      asyncState: 'success',
    },
    props<{ payload: GetSubmissionsResponse }>()
  );

  export const getSubmissionsFail = createAsyncAction(
    SubmissionApiActionTypes.GetSubmissionsFail,
    {
      asyncKey: SubmissionApiActionTypes.GetSubmissions,
      asyncState: 'fail',
    },
  );

  export const getSubmissionDetails = createAsyncAction(
    SubmissionApiActionTypes.GetSubmissionDetails,
    {
      asyncKey: SubmissionApiActionTypes.GetSubmissionDetails,
      asyncState: 'start',
    },
    props<{ userId: string, monitoredUserId: string, submissionId: string }>(),
  );

  export const getSubmissionDetailsSuccess = createAsyncAction(
    SubmissionApiActionTypes.GetSubmissionDetailsSuccess,
    {
      asyncKey: SubmissionApiActionTypes.GetSubmissionDetails,
      asyncState: 'success',
    },
    props<{ payload: SubmissionDetails }>()
  );

  export const getSubmissionDetailsFail = createAsyncAction(
    SubmissionApiActionTypes.GetSubmissionDetailsFail,
    {
      asyncKey: SubmissionApiActionTypes.GetSubmissionDetails,
      asyncState: 'fail',
    },
  );

  export const loadLatestSubmissionDetails = createAsyncAction(
    SubmissionApiActionTypes.LoadLatestSubmissionDetails,
    {
      asyncKey: SubmissionApiActionTypes.LoadLatestSubmissionDetails,
      asyncState: 'start',
    },
    props<{ userId: string, monitoredUserId: string}>(),
  );

  export const loadLatestSubmissionDetailsSuccess = createAsyncAction(
    SubmissionApiActionTypes.LoadLatestSubmissionDetailsSuccess,
    {
      asyncKey: SubmissionApiActionTypes.LoadLatestSubmissionDetailsSuccess,
      asyncState: 'success',
    },
    props<{ payload: SubmissionDetails }>()
  );

  export const loadLatestSubmissionDetailsFail = createAsyncAction(
    SubmissionApiActionTypes.LoadLatestSubmissionDetailsFail,
    {
      asyncKey: SubmissionApiActionTypes.LoadLatestSubmissionDetailsFail,
      asyncState: 'fail',
    },
  );

  export const clearSubmissionDetails = createAsyncAction(
    SubmissionApiActionTypes.ClearSubmissionDetails,
    {
      asyncKey: SubmissionApiActionTypes.ClearSubmissionDetails,
      asyncState: 'start',
    }
  );
}
